import React from "react";
import { Link } from "react-router-dom";
import localeText from "../../../../../locale";

const PartnerB2BAddressWarningBanner = () => (
  <div
    className="flex align-items-center gap-2 p-3 border-round mb-3"
    style={{
      backgroundColor: "rgba(255, 152, 0, 0.15)",
      border: "1px solid rgba(255, 152, 0, 0.5)",
      color: "var(--theme-text, #171717)",
    }}
  >
    <i className="pi pi-exclamation-triangle text-xl" style={{ color: "#e65100" }} />
    <span className="flex-1">{localeText("partnerB2bAddressWarningText")}</span>
    <Link
      to="/dashboard-editprofile/profile/contactInfo"
      className="font-semibold"
      style={{ color: "var(--theme-primary, #1DAF61)" }}
    >
      {localeText("partnerB2bConfigurePosition")}
    </Link>
  </div>
);

export default PartnerB2BAddressWarningBanner;
